import { Card, Grid, Icon, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import ModuleResources from "../module-resources";
import MDButton from "components/MDButton";
import RearrangeDialog from "./RearrangeDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import AddIcon from '@mui/icons-material/Add';
import { Add } from "@mui/icons-material";

const Modules = ({
    modules,
    setModules,
}) => {
    const [openModal, setOpenModal] = useState(false)
    const [activeModule, setActiveModule] = useState(0);
    const [localModuleName, setLocalModuleName] = useState(modules[activeModule].name);
    const [jumpToModule, setJumpToModule] = useState(activeModule + 1);
    const handleOpenModal = () => {
        setOpenModal(true);
    }
    const handleCloseModal = () => { setOpenModal(false) }
    // Adds a new module to the end and sets it as the active module
    const addModule = () => {
        const newModule = {
            name: "",
            resources: [],
        };
        const updatedModules = [...modules, newModule];
        setModules(updatedModules);
        setActiveModule(updatedModules.length - 1); // focus on new module
    };

    // Removes the currently active module
    const removeModule = () => {
        if (modules.length <= 1) return; // prevent deleting the last one
        const updatedModules = modules.filter((_, index) => index !== activeModule);
        setModules(updatedModules);
        setActiveModule((prev) => Math.max(prev - 1, 0)); // go back one if possible
    };
    useEffect(() => {
        setLocalModuleName(modules[activeModule].name);
    }, [activeModule, modules]);

    const nextModule = () => {
        setActiveModule((prev) => Math.min(prev + 1, modules.length - 1));
    };

    const prevModule = () => {
        setActiveModule((prev) => Math.max(prev - 1, 0));
    };
    return (
        <>
            <RearrangeDialog modules={modules} setModules={setModules} open={openModal} onClose={handleCloseModal} />
            <Grid item xs={12}>
                <Card style={{ width: "100%", padding: "20px", }}>

                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between">
                            <MDBox>
                                <MDTypography variant="h5" >
                                    Module {activeModule + 1}: {modules[activeModule].name}
                                </MDTypography>
                            </MDBox>
                            <MDBox display="flex" gap={1} >
                                <MDButton variant="gradient"
                                    startIcon={<SwapVertIcon />}
                                    onClick={() => {

                                        handleOpenModal();
                                    }}
                                    color="secondary">REARRANGE MODULES</MDButton>
                                <MDButton
                                    variant="gradient"
                                    color="info"
                                    startIcon={<Add />}
                                    onClick={() => addModule()}
                                >
                                    Add module
                                </MDButton>

                                <MDButton
                                    variant="gradient"
                                    color="error"
                                    startIcon={<DeleteIcon />}
                                    onClick={() => removeModule()}
                                >
                                    &nbsp;Remove Module
                                </MDButton>
                                <TextField
                                    label="Jump to Module"
                                    value={jumpToModule}
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => {
                                        setJumpToModule(e.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            const moduleIndex = parseInt(jumpToModule) - 1;
                                            if (moduleIndex >= 0 && moduleIndex < modules.length) {
                                                setActiveModule(moduleIndex);
                                                setJumpToModule(moduleIndex + 1);
                                            }

                                        }
                                    }}
                                    onBlur={(e) => {
                                        const moduleIndex = parseInt(jumpToModule) - 1;
                                        if (moduleIndex >= 0 && moduleIndex < modules.length) {
                                            setActiveModule(moduleIndex);
                                            setJumpToModule(moduleIndex + 1);
                                        }
                                    }}
                                />
                            </MDBox>
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} sx={{ pt: 2 }}>
                        <TextField
                            fullWidth
                            label="Module Name"
                            name="name"
                            value={localModuleName}
                            onChange={(e) => setLocalModuleName(e.target.value)}
                            onBlur={(e) => {
                                const updatedModules = [...modules];
                                updatedModules[activeModule] = {
                                    ...updatedModules[activeModule],
                                    name: localModuleName,
                                };
                                setModules(updatedModules);
                            }}
                        />
                    </Grid>
                    {/* Module cards */}
                    <Grid item xs={12} sx={{ pb: 4 }}>
                        <ModuleResources
                            module={modules[activeModule]}
                            moduleIndex={activeModule}
                            modules={modules}
                            setModules={setModules}
                        />
                    </Grid>

                    <Grid item xs={12} mt={1}>
                        <MDBox display="flex" justifyContent="space-between">
                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={prevModule}
                                disabled={activeModule === 0}
                            >
                                <Icon>arrow_back</Icon> &nbsp; Prev Module
                            </MDButton>
                            <MDTypography variant="h6" >
                                Module {activeModule + 1} of {modules.length}
                            </MDTypography>

                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={nextModule}
                                disabled={activeModule === modules.length - 1}
                            >
                                Next Module &nbsp; <Icon>arrow_forward</Icon>
                            </MDButton>
                        </MDBox>
                    </Grid>




                </Card>
            </Grid></>
    );
}

export default Modules;